document.addEventListener("DOMContentLoaded", function () {
    // Array of product handles for 10% off Bank Holiday offer
    const bankHolidayHandles = [
        // ALLROUND TEN 10' series
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-purple",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-blue",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-orange",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-azure",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-kintsugi",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-cyber",
        "aquaplanet-allround-ten-10-inflatable-paddle-board-package-spectre",

        // BOLT 9'4" series
        "aquaplanet-bolt-94-inflatable-paddle-board-package-blue",
        "aquaplanet-bolt-94-inflatable-paddle-board-package-coral",

        // ROCKIT 10'2" series
        "aquaplanet-rockit-10-2-inflatable-paddle-board-package-blue",
        "aquaplanet-rockit-10-2-inflatable-paddle-board-package-pink",

        // MAX 10'6" series
        "aquaplanet-max-10-6-inflatable-paddle-board-package-blue",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-orange",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-rainbow",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-prism",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-glacier-v2",
        "aquaplanet-max-10-6-inflatable-paddle-board-package-sunrise",

        // MAX Plus 11'8" series
        "aquaplanet-max-plus-118-inflatable-sup-package-horizon",
        "aquaplanet-max-plus-118-inflatable-sup-package-beach",

        // PACE series
        "aquaplanet-pace-sup-package-stand-up-inflatable-paddle-board-kit-10-6-long-teal-midnight",
        "aquaplanet-pace-sup-package-stand-up-inflatable-paddle-board-kit-10-6-long-red-blue",
        "aquaplanet-pace-118-inflatable-paddle-board-package-nori",
        "aquaplanet-pace-118-inflatable-paddle-board-package-ember",
        "aquaplanet-pace-10-6-inflatable-paddle-board-package-lagoon",
        "aquaplanet-pace-10-6-inflatable-paddle-board-package-coral",

        // Other Aquaplanet SUPs
        "aquaplanet-seeker-10-8-inflatable-paddle-board-package",
        "aquaplanet-jupiter-116-inflatable-paddle-board-package",
        "aquaplanet-cuda-expedition-14-inflatable-paddle-board-package",
        "aquaplanet-wingtail-9-inflatable-surf-sup-paddle-board-package",
        "aquaplanet-wilderness-adventure-108-inflatable-paddle-board-package",
        "aquaplanet-stinger-explorer-128-inflatable-paddle-board-package",

        // Hurley boards
        "hurley-advantage-terrazzo-10-inflatable-paddle-board-package",
        "hurley-advantage-black-tiger-10-inflatable-paddle-board-package",
        "hurley-advantage-outsider-10-6-inflatable-paddle-board-package",
        "hurley-apextour-malibu-118-inflatable-paddle-board-package",
        "hurley-apextour-freedom-118-inflatable-paddle-board-package",

        // Kayaks
        "aquaplanet-inflatable-kayak-one-person",
        "aquaplanet-inflatable-kayak-two-person",

        // Books / small accessories
        "paddling-britain-50-best-places-to-explore-by-sup-kayak-or-canoe",
        "aquaplanet-waterproof-phone-case",
        "aquaplanet-quick-release-belt",
        "aquaplanet-paddle-float",
        "aquaplanet-mini-sup-double-sided-rubber-keyring",
        "five-litre-roll-top-dry-bag",
        "aquaplanet-waterproof-tote-bag-20l-black",
        "aquaplanet-waterproof-tote-bag-20l-blue",
        "aquaplanet-self-inflating-roof-rack",
        "aquaplanet-pup-sup-pet-buoyancy-aid",
        "kayak-converter-bundle-kayak-seat-sup-kayak-paddle",
        "aquaplanet-iso-bath",

        // Paddles / pumps / buoyancy
        "hurley-3-piece-aluminium-paddle",
        "aquaplanet-carbon-fusionlite-paddle",
        "aquaplanet-carbon-fusionlite-paddle-1",
        "hurley-carbon-fusion-paddle",
        "aquaplanet-adjustable-paddle",
        "aquaplanet-sup-kayak-paddle",
        "aquaplanet-sup-kayak-paddle-blade-section",
        "aquaplanet-compact-2-0-electric-sup-pump",
        "aquaplanet-compact-3-0-electric-sup-pump",
        "aquaplanet-dual-action-pump",
        "hurley-gri-dual-action-pump",
        "aquaplanet-buoyancy-aid-pro",
        "aquaplanet-buoyancy-aid",

        // Robes / bags / seats / straps / leashes
        "aquaplanet-dry-waterproof-changing-robe-olive",
        "aquaplanet-dry-waterproof-changing-robe-black",
        "aquaplanet-hydrophonic-rucksack-for-sup",
        "aquaplanet-rucksack",
        "aquaplanet-kayak-seat",
        "sup-carry-strap",
        "aquaplanet-deluxe-leash",
        "aquaplanet-surf-leash-straight",

        // Clothing
        "aquaplanet-premium-cotton-t-shirt-mens",
        "aquaplanet-logo-premium-cotton-t-shirt-mens",
        "aquaplanet-logo-premium-cotton-t-shirt-womens",
        "aquaplanet-navy-performance-t-shirt-unisex",
        "aquaplanet-navy-eco-hoodie-unisex",
        "aquaplanet-performance-jacket-womens",
        "aquaplanet-performance-jacket-mens",
        "prolimit-sup-neoprene-hoody-1-5mm",
        "prolimit-rashguard-silk-longarm-mens",
        "prolimit-raider-shoe-v-strap",
        "prolimit-rashguard-loosefit-shortarm-womens",
        "prolimit-rashguard-loosefit-longarm-womens",
        "prolimit-sup-top-loosefit-pu-mens",
        "prolimit-grommet-shoe-2mm-black",
        "prolimit-fire-2mm-swimsuit",

        // Fins / spare parts
        "aquaplanet-slide-in-dolphin-fin",
        "aquaplanet-9-us-fin-for-2023-seeker-jupiter",
        "aquaplanet-tour-2-5-tpu-side-fin",
        "hurley-7-abs-fin",
        "aquaplanet-tour-9-abs-fin",
        "aquaplanet-4-5-slide-in-grp-fin",
        "aquaplanet-tour-4-5-tpu-fin",
        "hurley-us-sup-fin",
        "hurley-2022-range-paddle-middle-section-copy"
    ];

    const discountPercentage = 10;
    const discountCode = "ADVENTURE10";

    // Function to apply a percentage discount
    function applyPercentageDiscount(priceText, discountPercentage) {
        const price = parseFloat(priceText.replace(/[^0-9.]/g, ""));

        if (isNaN(price)) {
            return priceText;
        }

        const discountedPrice = price - (price * discountPercentage / 100);
        return `£${discountedPrice.toFixed(2)}`;
    }

    // Get the current URL path
    const urlParts = window.location.pathname.split("/");

    // Check if the page belongs to any collection
    const isCollectionPage = urlParts.includes("collections");
    const isProductPage = urlParts.includes("products");

    // 1. Handle collection pages and homepage
    if (isCollectionPage || window.location.pathname === "/") {
        const productCards = document.querySelectorAll(".cl-product-card-inner-container");

        productCards.forEach((card) => {
            const productLink = card.querySelector("a[href*='/products/']");

            if (productLink) {
                const productHandle = productLink
                    .getAttribute("href")
                    .split("/products/")
                    .pop()
                    .split("?")[0]
                    .split("#")[0];

                if (bankHolidayHandles.includes(productHandle)) {
                    const priceElement = card.querySelector(".price-variation");

                    if (priceElement) {
                        const currentPriceText = priceElement.textContent;
                        const discountedPrice = applyPercentageDiscount(currentPriceText, discountPercentage);
                        priceElement.textContent = `${discountedPrice} EXTRA 10% OFF with code ${discountCode}`;
                    }
                }
            }
        });
    }

    // 2. Handle product pages
    if (isProductPage) {
        const productHandle = urlParts[urlParts.indexOf("products") + 1];

        if (bankHolidayHandles.includes(productHandle)) {
            // Update main product price
            const priceSnippet = document.querySelector(".product-details-price-snippet .sale-price");

            if (priceSnippet) {
                const currentPriceText = priceSnippet.textContent;
                const discountedPrice = applyPercentageDiscount(currentPriceText, discountPercentage);
                priceSnippet.textContent = `${discountedPrice} EXTRA 10% OFF with code ${discountCode}`;
            }

            // Update price in add to cart section if exists
            const formPrice = document.querySelector(".product-form-price .price");

            if (formPrice) {
                const currentPriceText = formPrice.textContent;
                const discountedPrice = applyPercentageDiscount(currentPriceText, discountPercentage);
                formPrice.textContent = `${discountedPrice} EXTRA 10% OFF with code ${discountCode}`;
            }
        }
    }
});